import { UseBackendQueryArgs, useBackendQuery } from '../backend/useQuery'
import OnPremAgentClient from '../OnPremAgentClient/OnPremAgentClient'
import useOnPremAgentClient from '../OnPremAgentClient/useOnPremAgentClient'

type UseBackendQueryResponse<TResponseParams> = {
  data: TResponseParams | undefined
  loading: boolean
  error?: Error
  // Use this to update the data without re-fetching.
  // This is useful for optimistic updates based on user actions.
  setData: (data: TResponseParams | undefined) => void
}

export function useOnPremAgentQuery<TRequestParams = any, TResponseParams = any>({
  backendQueryParams: {
    apiQuery,
    // If apiParams is an object, it must be memoized. It is a useEffect dependency in useBackendQuery.
    apiParams,
    skip,
    pollInterval,
  },
}: UseBackendQueryArgs<
  TRequestParams,
  TResponseParams,
  OnPremAgentClient
>): UseBackendQueryResponse<TResponseParams> {
  const client = useOnPremAgentClient()
  let { data, loading, error, setData } = useBackendQuery(
    client,
    apiQuery,
    apiParams,
    skip,
    pollInterval,
  )
  return { data, loading, error, setData }
}

export default useOnPremAgentQuery
